import { Drawer as RawDrawer } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import React from 'react';

import Text, { TextProps } from './text';

export interface DrawerProps
  extends Omit<React.ComponentProps<typeof RawDrawer>, 'opened' | 'onClose'> {
  textProps?: TextProps;
  closeUnmount?: boolean;
}

export type DrawerRefType = {
  open: () => void;
  close: () => void;
  toggle: () => void;
};

const Drawer = React.forwardRef<DrawerRefType, DrawerProps>((props, ref) => {
  const { textProps, title, closeUnmount } = props;
  const [isOpened, { open, close, toggle }] = useDisclosure(false);

  React.useImperativeHandle(ref, () => {
    return {
      open,
      close,
      toggle,
    };
  });

  return (
    <RawDrawer
      opened={isOpened}
      onClose={close}
      title={
        typeof title === 'string' ? (
          <Text {...textProps} variant="h4Bold">
            {title}
          </Text>
        ) : (
          title
        )
      }
      closeOnClickOutside={false}
      zIndex={201}
      {...props}
    >
      {closeUnmount && isOpened === false ? null : props.children}
    </RawDrawer>
  );
});

Drawer.displayName = 'Drawer';

export default Drawer;
